const DEFAULT_TIMEOUT = 1e3 / 10;
class EventHandlersThrottler {
  constructor() {
    this.eventMutex = null;
  }
  /**
   * @param eventHandler Callback actually handling the event
   * @param timeout (optional) Time to wait before calling the callback
   */
  throttle(eventHandler, timeout) {
    if (this.eventMutex) {
      return;
    }
    this.eventMutex = setTimeout(() => {
      this.eventMutex = null;
      eventHandler();
    }, timeout || DEFAULT_TIMEOUT);
  }
}
export default EventHandlersThrottler;
